<template>
  <div class="wspo-tour-details">
    <div
      v-for="detail in details"
      :key="detail.name"
      class="wspo-tour-detail"
      :class="classOfType(detail.id)"
    >
      <div class="wspo-tour-detail-title wspo-icon">{{ detail.name }}</div>
      <div
        class="wspo-tour-detail-content wspo-list"
        v-if="Array.isArray(detail.content)"
      >
        <div
          class="wspo-list-item"
          v-for="(item, index) in detail.content"
          :key="index"
        >
          {{ item }}
        </div>
      </div>
      <div
        class="wspo-tour-detail-content"
        v-else
        v-html="detail.content"
      ></div>
    </div>
  </div>
</template>

<script>
const details = {
  placement: 'Местоположение',
  // phone: 'Телефон',
  // site: 'Сайт',
  build: 'Год постройки',
  repair: 'Год последнего ремонта',
  square: 'Площадь',
  lt_detail_info: 'Описание',
  lt_territory: 'На территории',
  lt_room_facilities: 'В номере "Стандарт"',
  services: 'список услуг',
  servicefree: 'Бесплатные услуги',
  servicepay: 'Платные услуги',
  lt_attractions: 'Развлечения',
  lt_kids: 'Детям',
  beach: 'Пляж',
  meallist: 'Питание'
};
export default {
  name: 'Details',
  props: {
    data: Object
  },
  computed: {
    details() {
      return this.data
        ? Object.entries(this.data)
            .filter(row => details.hasOwnProperty(row[0]) && row[1])
            .map(row => ({
              id: row[0],
              name: details[row[0]],
              content: !Array.isArray(row[1])
                ? row[1]
                    .replace(/&lt;/g, '<')
                    .replace(/&gt;/g, '>')
                    .replace(/&amp;/g, '&')
                    .replace(/&nbsp;/g, ' ')
                    .replace(/&quot;/g, '"')
                    .trim()
                : row[1].map(r =>
                    r
                      .replace(/&lt;/g, '<')
                      .replace(/&gt;/g, '>')
                      .replace(/&amp;/g, '&')
                      .replace(/&nbsp;/g, ' ')
                      .replace(/&quot;/g, '"')
                      .trim()
                  )
            }))
        : {};
    },
    classOfType() {
      return type => `wspo-tour-detail-${type}`;
    }
  }
};
</script>

<style>
.wspo-list {
  padding: 0;
  margin: 0;
  list-style-type: none;
}
.wspo-list-item:before {
  content: '';
  display: inline-flex;
  width: 8px;
  height: 8px;
  border-radius: 2px;
  background-color: var(--color-bg-dark);
  margin-right: 8px;

  margin-left: -22px;
}
</style>

<style scoped>
.wspo-tour-details {
  display: flex;
  flex-wrap: wrap;
  border-top: 1px solid var(--color-alt-5);
  border-left: 1px solid var(--color-alt-5);
  max-height: 557px;
  overflow: auto;
}
@media (max-width: 1000px) {
  .wspo-tour-details {
    max-height: unset;
  }
}

.wspo-tour-detail {
  flex: 1 1 300px;
  border-right: 1px solid var(--color-alt-5);
  background-color: var(--color-paper);
  /* border-bottom: 1px solid var(--color-alt-5); */
}
.wspo-tour-detail-title {
  padding: 8px;
  background-color: var(--color-bg);
}
.wspo-tour-detail-title:before {
  margin-right: 8px;
  font-size: 18px;
  color: var(--color-alt);
}
.wspo-tour-detail-content {
  padding: 8px 36px;
  background-color: var(--color-paper);
}
.wspo-tour-detail-build,
.wspo-tour-detail-repair,
.wspo-tour-detail-square {
  order: -1;
}
.wspo-tour-detail-build .wspo-tour-detail-title:before {
  content: '\f6e3';
}
.wspo-tour-detail-repair .wspo-tour-detail-title:before {
  content: '\f7d9';
}
.wspo-tour-detail-square .wspo-tour-detail-title:before {
  content: '\f546';
}
.wspo-tour-detail-lt_detail_info .wspo-tour-detail-title:before {
  content: '\f27a';
}
.wspo-tour-detail-placement .wspo-tour-detail-title:before {
  content: '\f5a0';
}
.wspo-tour-detail-lt_territory .wspo-tour-detail-title:before {
  content: '\f594';
}
.wspo-tour-detail-lt_room_facilities .wspo-tour-detail-title:before {
  content: '\f52b';
}
.wspo-tour-detail-services .wspo-tour-detail-title:before {
  content: '\f562';
}
.wspo-tour-detail-servicepay .wspo-tour-detail-title:before {
  content: '\f4c0';
}
.wspo-tour-detail-servicefree .wspo-tour-detail-title:before {
  content: '\f4bd';
}
.wspo-tour-detail-lt_attractions .wspo-tour-detail-title:before {
  content: '\f59a';
}
.wspo-tour-detail-lt_kids .wspo-tour-detail-title:before {
  content: '\f1ae';
}
.wspo-tour-detail-beach .wspo-tour-detail-title:before {
  content: '\f5ca';
}
.wspo-tour-detail-meallist .wspo-tour-detail-title:before {
  content: '\f725';
}
</style>
